import React, { useRef, useEffect } from 'react'
import { useOnScreen } from '../utils/useOnScreen'
import { useSectionInViewContext } from '../context/SectionInViewContext'

export const SectionInView = ({ children, id }: any) => {
  const sectionRef = useRef<any>()
  const onScreen = useOnScreen(sectionRef, '-400px')
  const { setVisibleSection } = useSectionInViewContext()

  useEffect(() => {
    if (onScreen) {
      setVisibleSection(id)
    }
  }, [onScreen])

  return <div ref={sectionRef}>{children}</div>
}
